import { Controller } from "@hotwired/stimulus"

// Opens Intercom with a pre-filled message (home planroom access request).
export default class extends Controller {
  static values = { message: String }

  launch(event) {
    event.preventDefault()
    if (typeof Intercom !== "function") return

    Intercom("showMessages")
    Intercom("showNewMessage", this.messageValue)
  }
}
